import { combineReducers } from 'redux';
import { combineActions, handleActions } from 'redux-actions';
import { CREATE_ORDER_SUCCESS } from '../../../order/create/containers/constants';
import * as constants from '../constants';

export const action = handleActions(
  {
    [constants.FETCH_SMART_ACTION_SUCCESS]: (state, { payload }) => payload.ticketAction,
    [combineActions(
      'LOCATION_CHANGE',
      constants.FETCH_SMART_ACTION,
      constants.FETCH_SMART_ACTION_FAILURE,
    )]: () => ({}),
  },
  {},
);

export const isLoadingAction = handleActions(
  {
    [constants.FETCH_SMART_ACTION]: () => true,
    [combineActions(
      constants.FETCH_SMART_ACTION_SUCCESS,
      constants.FETCH_SMART_ACTION_FAILURE,
    )]: () => false,
  },
  false,
);

export const isSaving = handleActions(
  {
    [combineActions(
      constants.SAVE_SMART_ACTION_SUCCESS,
      constants.SAVE_SMART_ACTION_FAILURE,
      constants.CREATE_SMART_ACTION_SUCCESS,
      constants.CREATE_SMART_ACTION_FAILURE,
    )]: () => false,
    [combineActions(constants.SAVE_SMART_ACTION, constants.CREATE_SMART_ACTION)]: () => true,
  },
  false,
);

export const success = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.SAVE_SMART_ACTION,
      constants.SAVE_SMART_ACTION_FAILURE,
      constants.CREATE_SMART_ACTION,
      constants.CREATE_SMART_ACTION_FAILURE,
      constants.RESET_SMART_ACTION_SUCCESS,
    )]: () => false,
    [combineActions(constants.SAVE_SMART_ACTION_SUCCESS, constants.CREATE_SMART_ACTION_SUCCESS)]: (
      state,
      { payload },
    ) => payload,
  },
  false,
);

export const saveSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.SAVE_SMART_ACTION,
      constants.SAVE_SMART_ACTION_FAILURE,
    )]: () => false,
    [combineActions(constants.SAVE_SMART_ACTION_SUCCESS)]: (
      state,
      { payload },
    ) => payload,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.SAVE_SMART_ACTION,
      constants.SAVE_SMART_ACTION_SUCCESS,
      constants.CREATE_SMART_ACTION,
      constants.CREATE_SMART_ACTION_SUCCESS,
    )]: () => ({}),
    [combineActions(constants.SAVE_SMART_ACTION_FAILURE, constants.CREATE_SMART_ACTION_FAILURE)]: (
      state,
      { payload },
    ) => payload.error,
  },
  {},
);

export const isDeleting = handleActions(
  {
    [combineActions(
      constants.DELETE_SMART_ACTION_SUCCESS,
      constants.DELETE_SMART_ACTION_FAILURE,
    )]: () => false,
    [constants.DELETE_SMART_ACTION]: () => true,
  },
  false,
);

export const deleteSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.DELETE_SMART_ACTION,
      constants.DELETE_SMART_ACTION_FAILURE,
    )]: () => false,
    [constants.DELETE_SMART_ACTION_SUCCESS]: () => true,
  },
  false,
);

export const deleteError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      constants.DELETE_SMART_ACTION,
      constants.DELETE_SMART_ACTION_SUCCESS,
    )]: () => ({}),
    [combineActions(constants.DELETE_SMART_ACTION_FAILURE)]: (state, { payload }) => payload.error,
  },
  {},
);

export const actionForCreatingOrder = handleActions(
  {
    [combineActions(constants.SET_ACTION_FOR_CREATING_ORDER)]: (state, { payload }) => payload,
    [combineActions(
      constants.FETCH_SMART_ACTION_SUCCESS,
      constants.SAVE_SMART_ACTION_SUCCESS,
      constants.SAVE_SMART_ACTION_FAILURE,
      constants.CREATE_SMART_ACTION,
      constants.CREATE_SMART_ACTION_SUCCESS,
      constants.CREATE_SMART_ACTION_FAILURE,
      constants.DELETE_SMART_ACTION,
      constants.DELETE_SMART_ACTION_SUCCESS,
      constants.DELETE_SMART_ACTION_FAILURE,
      CREATE_ORDER_SUCCESS,
    )]: () => ({}),
  },
  {},
);

export const operations = handleActions(
  {
    [constants.FETCH_SMART_ACTION_SUCCESS]: (state, { payload }) =>
      payload?.ticketAction?.operations?.map(o => ({
        ...o,
        addToOrder: true,
      })),
    [constants.UPDATE_OPERATIONS]: (state, { payload }) => payload,
    [combineActions(
      'LOCATION_CHANGE',
      constants.FETCH_SMART_ACTION,
      constants.SAVE_SMART_ACTION_SUCCESS,
      CREATE_ORDER_SUCCESS,
    )]: () => [],
  },
  [],
);

export const parts = handleActions(
  {
    [constants.FETCH_SMART_ACTION_SUCCESS]: (state, { payload }) =>
      payload?.ticketAction?.parts?.map(p => ({
        ...p,
        addToOrder: true,
      })),
    [constants.UPDATE_PARTS]: (state, { payload }) => payload,
    [combineActions(
      'LOCATION_CHANGE',
      constants.FETCH_SMART_ACTION,
      constants.SAVE_SMART_ACTION_SUCCESS,
      CREATE_ORDER_SUCCESS,
    )]: () => [],
  },
  [],
);

export default combineReducers({
  action,
  isSaving,
  success,
  error,
  isDeleting,
  deleteSuccess,
  deleteError,
  actionForCreatingOrder,
  isLoadingAction,
  saveSuccess,
  operations,
  parts,
});
